import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { useRef as z, useState as q, useEffect as C } from "react";
import { useTranslation as B } from "react-i18next";
import _ from "classnames";
import "../../components/Breadcrumbs/index.js";
import F from "../../components/Button/index.js";
import "reactjs-popup";
import W from "../../icons/Checkmark.js";
import A from "../../icons/Trash.js";
import E from "../../icons/QuestionCircle.js";
import $ from "../../icons/Attention.js";
import "../../components/ThemeContext/index.js";
import j from "../../components/Modal/index.js";
import "../../fields/Input/index.js";
import M from "../../components/Tooltip/index.js";
import "../../fields/FieldContainer/index.js";
import "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import "../../fields/DateInput/index.js";
import "date-fns";
import "../../fields/Select/index.js";
import "react-dropzone";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import H from "../../fields/Switcher/index.js";
import "../../fields/Textarea/index.js";
import "../../fields/Wysiwyg/index.js";
import L from "../FillingInput/index.js";
const O = "forma-ui__filling-item__item", Q = "forma-ui__filling-item__filled", V = "forma-ui__filling-item__icon", X = "forma-ui__filling-item__error", Z = "forma-ui__filling-item__superfield", D = "forma-ui__filling-item__label", G = "forma-ui__filling-item__labelText", J = "forma-ui__filling-item__required", K = "forma-ui__filling-item__labelButtons", P = "forma-ui__filling-item__info", R = "forma-ui__filling-item__tooltip", U = "forma-ui__filling-item__remove", Y = "forma-ui__filling-item__removeIcon", ii = "forma-ui__filling-item__inputSizer", ei = "forma-ui__filling-item__hidden", ti = "forma-ui__filling-item__notice", i = {
  item: O,
  filled: Q,
  icon: V,
  error: X,
  superfield: Z,
  label: D,
  labelText: G,
  required: J,
  labelButtons: K,
  info: P,
  tooltip: R,
  remove: U,
  removeIcon: Y,
  inputSizer: ii,
  hidden: ei,
  notice: ti
}, N = 24, Wi = ({
  data: m,
  form: r,
  isSuperField: k,
  isFilledDynamicly: x,
  value: t,
  onRemove: p,
  onSelect: u,
  selected: a,
  showSelect: f,
  ...y
}) => {
  const { t: l } = B(), o = z(null), { id: n, name: h, inputTooltip: S, inputWidth: d = 216, description: g, hidden: T, multiple: I } = m, [v, b] = q(d);
  C(() => {
    o != null && o.current && d < o.current.scrollWidth + N ? b(o.current.scrollWidth + N) : b(d);
  }, [t, o]);
  let s = "";
  return Array.isArray(t) ? s = t[0] + "---" : t && (I ? s = t.split(",")[0] : s = t.replace(/\r\n|\r|\n/g, "<br />")), /* @__PURE__ */ c(
    "div",
    {
      id: `filling_item_${n}`,
      className: _(
        i.item,
        r.error && i.error,
        (k || x) && i.superfield,
        T && i.hidden,
        t && !r.error && i.filled
      ),
      style: { width: v + "px" },
      "data-testid": `filling_item_${n}`,
      children: [
        /* @__PURE__ */ c("div", { className: i.label, children: [
          /* @__PURE__ */ e("span", { className: _(i.labelText, m.required !== !1 && i.required), children: h }),
          /* @__PURE__ */ c("span", { className: i.labelButtons, children: [
            g && /* @__PURE__ */ e(
              M,
              {
                position: ["bottom left", "bottom right", "bottom center"],
                className: i.tooltip,
                control: /* @__PURE__ */ e("span", { className: i.info, children: /* @__PURE__ */ e(E, {}) }),
                offsetX: 0,
                children: g
              }
            ),
            f && u && /* @__PURE__ */ e(
              H,
              {
                containerClass: i.switcher,
                name: `filling_item_checkbox_${n}`,
                size: "small",
                onChange: (w) => u(n, w.target.checked),
                checked: !!a
              }
            ),
            p && m.required === !1 && /* @__PURE__ */ e(
              j,
              {
                size: "small",
                control: /* @__PURE__ */ e(
                  F,
                  {
                    className: i.remove,
                    viewStyle: "text",
                    iconClassName: i.removeIcon,
                    icon: /* @__PURE__ */ e(A, {}),
                    title: l("uikit:delete")
                  }
                ),
                title: /* @__PURE__ */ c("span", { children: [
                  l("uikit:do_yo_want_delete"),
                  " “",
                  h,
                  "”?"
                ] }),
                buttons: [
                  {
                    children: l("uikit:delete"),
                    viewStyle: "danger",
                    onClick: () => p(n)
                  },
                  {
                    children: l("uikit:cancel"),
                    viewStyle: "tertiary"
                  }
                ]
              }
            )
          ] })
        ] }),
        f && a && /* @__PURE__ */ e("div", { className: i.notice, children: l("uikit:sending_to_filling") }),
        /* @__PURE__ */ e("div", { className: _(f && a && i.hidden), children: /* @__PURE__ */ e(
          L,
          {
            ...y,
            data: m,
            form: r,
            value: t,
            tooltip: r.error ?? S,
            icon: r.error ? /* @__PURE__ */ e($, { className: i.icon, width: 24, height: 24 }) : t && /* @__PURE__ */ e(W, { className: i.icon, width: 24, height: 24 })
          }
        ) }),
        /* @__PURE__ */ e(
          "div",
          {
            className: i.inputSizer,
            dangerouslySetInnerHTML: { __html: s },
            ref: o
          }
        )
      ]
    }
  );
}, Ai = () => /* @__PURE__ */ e("div", { className: _(i.item, "skeleton-loader") });
export {
  Ai as FillingItemSkelet,
  Wi as default
};
